import Link from 'next/link'
import { useRouter, withRouter } from 'next/router'
import { useContext, useState } from 'react'
import { ButtonCategoria, SidebarMain, SidebarSub, StyleSidebar } from './style'

import { IconArrow, IconArrowBack, IconMenu } from '@gazin/ecommerce-ui'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import InfoSiteFooter from './components/infoSiteFooter'

const ComponentCategoriaMobile = () => {
  const { isBlackFridayTheme } = useBlackFriday()
  const { menuCategoriasData } = useGlobalContext()
  const router = useRouter()

  const [showCategorie, setShowCategorie] = useState(false)
  const [showMenuMain, setShowMenuMain] = useState(false)
  const [showSubmenu, setShowSubmenu] = useState(false)
  const [subCategorias, setSubCategorias] = useState([])
  const [categoriaNome, setCategoriaNome] = useState('')

  const mostrarCategoria = (cat) => {
    const buscaSubCategoria = menuCategoriasData.itens?.find(
      (categoria) => categoria.nome === cat.nome
    )

    if (!buscaSubCategoria) return router.push(`/categoria/${cat.slug}`)

    setSubCategorias(buscaSubCategoria)
    setCategoriaNome(cat.nome)
    setShowSubmenu(true)
  }

  return (
    <div>
      <ButtonCategoria
        onClick={() => {
          setShowCategorie(true)
          setShowMenuMain(true)
        }}
        aria-label="Menu categorias"
      >
        <IconMenu color="#fff" />
      </ButtonCategoria>

      <StyleSidebar visibleCategories={showCategorie}>
        <SidebarMain
          visibleMainSidebar={showMenuMain}
          darkTheme={isBlackFridayTheme}
        >
          <div className="topo">
            <button
              onClick={() => {
                setShowCategorie(false)
                setShowMenuMain(false)
              }}
            >
              <IconArrowBack
                color="#fff"
                width=".5rem"
                height=".875rem"
                marginRight="1.5625rem"
              />
              Categorias
            </button>
          </div>

          <div className="cont-menu">
            <ul>
              {menuCategoriasData?.itens?.map((categoria, key_categoria) => (
                <li
                  onClick={() => mostrarCategoria(categoria)}
                  key={key_categoria}
                >
                  <button className="js-next-sidebar">
                    {categoria.nome}
                    <IconArrow
                      width=".4375rem"
                      height=".6875rem"
                      color="#646981"
                    />
                  </button>
                </li>
              ))}
            </ul>

            <InfoSiteFooter darkTheme={isBlackFridayTheme} />
          </div>
        </SidebarMain>

        <SidebarSub
          visibleSubSidebar={showSubmenu}
          darkTheme={isBlackFridayTheme}
        >
          <div className="topo">
            <button
              onClick={() => {
                setShowSubmenu(false)
                setShowMenuMain(true)
              }}
            >
              <IconArrowBack
                color="#fff"
                width=".5rem"
                height=".875rem"
                marginRight="1.5625rem"
              />
              {categoriaNome}
            </button>
          </div>

          <div className="cont-menu">
            <ul>
              {subCategorias &&
              subCategorias.parametros &&
              subCategorias.parametros.categoria_slug ? (
                <li key={subCategorias.parametros.categoria_slug}>
                  <Link
                    as={`/categoria/${
                      subCategorias.parametros.categoria_slug
                        ? subCategorias.parametros.categoria_slug
                        : ''
                    }`}
                    href="/categoria/[...categoria]"
                    prefetch={false}
                    onClick={() => {
                      setShowSubmenu(false)
                      setShowMenuMain(true)
                      setShowCategorie(false)
                      setShowMenuMain(false)
                    }}
                  >
                    {subCategorias.nome}
                  </Link>
                </li>
              ) : null}

              {!subCategorias?.itens ? null : (
                <>
                  {subCategorias.itens.map((subCategoria, key_subCategoria) => (
                    <li key={key_subCategoria}>
                      <div>
                        <Link
                          as={
                            subCategoria.parametros.categoria_slug
                              ? `/categoria/${subCategoria.parametros.categoria_slug}`
                              : ''
                          }
                          href="/categoria/[...categoria]"
                          prefetch={false}
                          onClick={() => {
                            setShowSubmenu(false)
                            setShowCategorie(false)
                            setShowMenuMain(false)
                          }}
                        >
                          {subCategoria.nome}
                        </Link>
                      </div>
                    </li>
                  ))}
                </>
              )}
            </ul>

            <InfoSiteFooter darkTheme={isBlackFridayTheme} />
          </div>
        </SidebarSub>
      </StyleSidebar>
    </div>
  )
}

export default withRouter(ComponentCategoriaMobile)
